export default "__VITE_ASSET__CCO2XSw1__"